// Reporte por equipo: cuántos días se usó, qué tan ocupado estuvo y cuánto dejó.
import { el, clear } from '../../utils/dom.js';
import { Rentals } from '../../api/resources.js';
import { fmtMoney } from '../../utils/format.js';
import { navigate } from '../../router/index.js';

const hoy = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santo_Domingo' }).format(new Date());
const sumar = (dia, n) => { const [y, m, d] = dia.split('-').map(Number); return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10); };

export default async function ReportePage(outlet, ctx) {
  clear(outlet);
  const dias = Math.min(62, Math.max(1, parseInt(ctx.query?.dias || '30', 10)));
  const desde = /^\d{4}-\d{2}-\d{2}$/.test(ctx.query?.desde || '') ? ctx.query.desde : sumar(hoy(), -dias + 1);
  let filas = [];
  try { filas = await Rentals.reporte({ desde, dias }); }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  const inDesde = el('input', { class: 'input', type: 'date', value: desde, 'aria-label': 'Desde' });
  const inDias = el('select', { class: 'select', 'aria-label': 'Días' },
    ...[7, 30, 60].map((n) => { const o = el('option', { value: n }, `${n} días`); if (n === dias) o.selected = true; return o; }));
  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {}, el('h1', {}, 'Reporte de ocupación'), el('div', { class: 'muted' }, 'Uso e ingresos por equipo')),
    el('a', { href: '#/rentals', class: 'btn ghost' }, '← Rentas')));
  outlet.appendChild(el('div', { class: 'toolbar wrap' }, inDesde, inDias,
    el('button', { class: 'btn primary', onclick: () => navigate(`/rentals/reporte?desde=${inDesde.value}&dias=${inDias.value}`) }, 'Ver'),
    el('button', { class: 'btn', onclick: () => {
      const csv = [['Equipo', 'Días con uso', 'Días', '% uso', 'Unidades-día ocupadas', 'Capacidad', 'Ingresos', 'Rentas']]
        .concat(filas.map((f) => [f.nombre, f.dias_con_uso, f.dias, f.capacidad ? Math.round((f.unidades_dia / f.capacidad) * 100) : '',
          f.unidades_dia, f.capacidad, f.ingresos, f.rentas]))
        .map((r) => r.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n');
      const a = el('a', { href: URL.createObjectURL(new Blob(['﻿' + csv], { type: 'text/csv' })), download: `ocupacion-${desde}.csv` });
      a.click();
    } }, 'Descargar CSV')));

  const total = filas.reduce((s, f) => s + Number(f.ingresos), 0);
  outlet.appendChild(el('p', { class: 'muted' }, `Ingresos de rentas que empezaron en el periodo: ${fmtMoney(total)}`));
  outlet.appendChild(el('div', { class: 'card', style: 'padding:0;overflow-x:auto' }, el('table', { class: 'table' },
    el('thead', {}, el('tr', {}, ...['Equipo', 'Uso', 'Ocupación', 'Ingresos', 'Rentas'].map((t) => el('th', {}, t)))),
    el('tbody', {}, ...filas.map((f) => {
      const pct = f.capacidad ? Math.round((f.unidades_dia / f.capacidad) * 100) : null;
      return el('tr', {},
        el('td', {}, f.nombre, f.es_kit ? el('span', { class: 'badge info', style: 'margin-left:6px' }, 'combo') : null),
        el('td', {}, f.es_kit ? '—' : `${f.dias_con_uso} de ${f.dias} días`),
        el('td', {}, pct == null ? '—' : el('div', { class: 'flex items-center gap-2' },
          el('div', { style: 'width:90px;height:8px;border-radius:99px;background:var(--surface-3);overflow:hidden' },
            el('div', { style: `width:${pct}%;height:100%;background:var(--primary)` })), `${pct} %`)),
        el('td', {}, fmtMoney(f.ingresos)),
        el('td', {}, String(f.rentas)));
    })))));
  if (!filas.length) outlet.appendChild(el('p', { class: 'muted mt-3' }, 'Sin uso en ese periodo.'));
}
